const PUBLIC_URL = process.env.PUBLIC_URL || ''

function mvmModalAsset(filename: string): string {
  return `${PUBLIC_URL}/assets/mvm-modal/${filename.replace(/^\//, '')}`
}

export const MVM_MODAL_BG_URL = mvmModalAsset('modal_bg.webp')
export const MVM_MODAL_VICTORY_LOGO_BG_URL = mvmModalAsset('victory_logo_bg.webp')
export const MVM_MODAL_DEFEAT_LOGO_BG_URL = mvmModalAsset('defeat_logo_bg.webp')
export const MVM_MODAL_BATTLE_REWARDS_BG_URL = mvmModalAsset('battle_rewards_bg.webp')
export const MVM_MODAL_BORDER_URL = mvmModalAsset('border.webp')
export const MVM_MODAL_DEFEAT_BACK_BTN_URL = mvmModalAsset('defeat_back_btn.webp')
export const MVM_MODAL_VICTORY_BACK_BTN_URL = mvmModalAsset('victory_back_btn.webp')
export const MVM_MODAL_LOOT_CARD_BG_URL = mvmModalAsset('loot_card_bg.webp')

/** Precache all MvM battle end modal art (`public/assets/mvm-modal/`). */
export const MVM_MODAL_PRECACHE_URLS: readonly string[] = [
  MVM_MODAL_BG_URL,
  MVM_MODAL_VICTORY_LOGO_BG_URL,
  MVM_MODAL_DEFEAT_LOGO_BG_URL,
  MVM_MODAL_BATTLE_REWARDS_BG_URL,
  MVM_MODAL_BORDER_URL,
  MVM_MODAL_DEFEAT_BACK_BTN_URL,
  MVM_MODAL_VICTORY_BACK_BTN_URL,
  MVM_MODAL_LOOT_CARD_BG_URL,
]
